import store from '@/store/index'
import api from '@/api'

const WxAppIdKey = 'wxAppid'

function getStoredWxAppId () {
  try {
    return window.localStorage.getItem(WxAppIdKey) || ''
  } catch (error) {
    return ''
  }
}

function setStoredWxAppId (wxAppId) {
  try {
    if (wxAppId) {
      window.localStorage.setItem(WxAppIdKey, wxAppId)
    } else {
      window.localStorage.removeItem(WxAppIdKey)
    }
  } catch (error) {
    // 隐私模式禁止访问本地存储时，仅使用 Vuex 中的内存状态
  }
}

let initializationPromise = null

const wechatStore = {
  state: {
    publicAccountList: [],
    wxAppid: getStoredWxAppId(),
    initialized: false
  },
  getters: {
    getWxAppid: (state) => state.wxAppid,
    isWechatInitialized: (state) => state.initialized
  },
  mutations: {
    SET_PUBLIC_ACCOUNTS (state, accounts) {
      state.publicAccountList = accounts
    },
    SET_WX_APPID (state, wxAppId) {
      state.wxAppid = wxAppId || ''
      setStoredWxAppId(state.wxAppid)
    },
    SET_WECHAT_INITIALIZED (state, initialized) {
      state.initialized = initialized
    }
  },
  actions: {
    async fetchPublicAccounts ({ commit }, appId = store.getters.appId) {
      const res = await api.getWeixinList(appId)
      const accounts = Array.isArray(res.data) ? res.data : []
      commit('SET_PUBLIC_ACCOUNTS', accounts)
      return accounts
    },
    async updateWxAppid ({ state, commit, dispatch }, wxAppId) {
      commit('SET_WX_APPID', wxAppId)
      const account = state.publicAccountList.find(item => item.wxAppId === wxAppId)
      if (account) {
        await dispatch('ChangeGame', account.appId)
      }
      return state.wxAppid
    },
    initializeWechatContext ({ state, getters, commit, dispatch, rootGetters }) {
      if (state.initialized) {
        return Promise.resolve(getters.getWxAppid)
      }
      if (initializationPromise) {
        return initializationPromise
      }

      initializationPromise = (async () => {
        try {
          await dispatch('GetGames')
          const accounts = await dispatch('fetchPublicAccounts', rootGetters.appId)
          const storedWxAppId = getStoredWxAppId()
          const selectedAccount = accounts.find(item => item.wxAppId === storedWxAppId) ||
            accounts.find(item => `${item.appId}` === `${rootGetters.appId}`) ||
            accounts[0]

          if (!selectedAccount) {
            commit('SET_WX_APPID', '')
            commit('SET_WECHAT_INITIALIZED', true)
            return ''
          }

          await dispatch('updateWxAppid', selectedAccount.wxAppId)
          commit('SET_WECHAT_INITIALIZED', true)
          return selectedAccount.wxAppId
        } finally {
          initializationPromise = null
        }
      })()

      return initializationPromise
    }
  }
}

export default wechatStore
